import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver, checkLanguageCookie } from '../../utils/utils';

@Component({
  tag: 'solution-card',
  styleUrl: 'solution-card.css',
  shadow: true,
})
export class SolutionCard {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * Button Text
   */
  @Prop() buttonText: string;

  /**
   * Jobs Text
   */
  @Prop() jobsText: string;

  /**
   * Text Orientation
   */
  @Prop() textOrientation: string;

  /**
   * Cards Data
   */
  @Prop() cardsData: string;

  /**
   * Pagination
   */
  @Prop() pagination: string;

  /**
   * Jobs
   */
  @Prop() jobs: string;

  /**
   * position
   */
  @Prop() position: string;

  /**
   * leadership
   */
  @Prop() leadership: string;

  /**
   * Career Cards
   */
  @Prop() careerCards: string;

  /**
   * Buttons Data
   */
  @Prop() buttonData: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  /**
   * Card Type
   */
  @Prop() cardType: string;

  @Element() el: HTMLElement;

  componentDidLoad() {
    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.cards-wrapper '),
      () => {
        this.el.shadowRoot.querySelector('.cards-wrapper ').classList.add('animate');
      },
      ['.overlay1', '.overlay2', '.overlay3', '.overlay4', '.overlay5', '.overlay6'],
    );

    // Add hover effect to cards only if card-overlay is present

    if (!this.el.shadowRoot.querySelector('.card-overlay')) {
      return;
    }
    this.el.shadowRoot.querySelector('.card .card-overlay').addEventListener('mouseover', function () {
      this.parentNode.classList.add('bg-ui-gray-5');
    });

    this.el.shadowRoot.querySelector('.card .card-overlay').addEventListener('mouseout', function () {
      this.parentNode.classList.remove('bg-ui-gray-5');
    });
  }
  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }
  render() {
    const cards = JSON.parse(this.cardsData);
    const count = cards.length;
    const cardType = this.cardType;
    // Get the language code from the cookie
    const langCode = checkLanguageCookie('wp-wpml_current_language');
    // Construct the href dynamically
    const href = langCode ? `/${langCode}/3e-solutions` : '/3e-solutions';
    //console.log(cards);
    return (
      <Host>
        <section
          class={`solution-cards-section ${this.backgroundColor}`}
          style={{ backgroundImage: `url(${this.backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
        >
          <div
            class={`solution-cards-wrapper flex flex-col items-center ${!this.jobs && 'container'} ${this.pagination && 'pagination'}  justify-center ${
              this.paddingBottom === '' ? 'pb-medium' : this.paddingBottom
            } ${this.paddingTop === '' ? 'pt-medium' : this.paddingTop} ${this.textColor} ${this.pagination ? 'pagination-cards-wrapper' : ''}  `}
          >
            <div class={`w-full flex justify-between`}>
              {this.mainTitle && <h2 class={` text-center fs-4 font-bold mb-32px text-ui-gray-1 ${this.textOrientation}`}>{this.mainTitle}</h2>}
            </div>
            <div
              class={`cards-wrapper ${cardType && 'layout-author'} ${this.leadership && 'layout-leadership'}  ${this.pagination && !this.jobs ? 'layout-pagination' : ''} ${
                !this.pagination && this.jobs ? 'layout-jobs' : this.pagination || this.jobs ? '' : `layout-${count} ${cards.length == 3 ? 'card-wrapper-wide-gap' : ''}`
              } `}
            >
              {count > 0 &&
                cards.map(({ title, category, description, image_url, image_alt, link, location, jobDescription, position }, index) => (
                  <div class={` card hover:bg-ui-gray-5 transition-colors`}>
                    <div class={`overlay${index + 1}`}></div>
                    <div class={`card-description-wrapper ${cards.length <= 3 && cards.length > 1 ? 'card-description-wrapper-medium' : ''}`}>
                      {category && <p class={`card-category`}>{category}</p>}
                      {title && <h3 class={`card-title`}>{title}</h3>}
                      {position && <p class={`card-position my-8px text-ui-gray-2 font-normal`}>{position}</p>}
                      {location && <p class={`card-location`}>{location}</p>}
                      {((description && cards.length < 5) || this.pagination) && <p class={`card-description`} innerHTML={description}></p>}
                      {jobDescription && (this.jobs || this.careerCards) && <p class={`card-description `} innerHTML={jobDescription}></p>}

                      {link && count === 1 && !this.jobs && !this.pagination && (
                        <a class={`linkedin-btn`} href={link}>
                          More content from {title.split(' ')[0]}
                        </a>
                      )}
                    </div>
                    {!this.jobs && !this.careerCards && (
                      <div class="card-image-container relative overflow-hidden ">
                        {/* {image_url && <image-block imageUrl={image_url} imageAlt={image_alt} imageClass={`solution-card-image`}></image-block>} */}
                        {image_url && <img src={image_url} alt={image_alt ? image_alt : title} class={`card-image`} width={400} height={400} />}
                        {link && (count > 1 || this.pagination) && !this.leadership && <div class={`card-link `}></div>}
                      </div>
                    )}
                    {link && (count > 0 || this.jobs) && !this.leadership && <div class={`card-link `}></div>}
                    {link && this.leadership && <div class={`card-link leadership `}></div>}

                    {link && (count > 0 || this.pagination || this.jobs) && <a class={`card-overlay`} href={link}></a>}
                  </div>
                ))}

              {!this.pagination && count > 0 && !this.jobs && !this.careerCards && cards.length < 5 && !this.leadership && cardType !== 'author-card' && (
                <div class={`solution-view-more-card`}>
                  <div class={`lg:p-16px w-full `}>
                    <h3 class={`text-medium-blue fs-0`}>{this.buttonText}</h3>
                    <a class={`card-overlay group-target`} href={href}></a>
                  </div>
                </div>
              )}

              {this.careerCards && (
                <div class={`solution-view-more-card`}>
                  <div class={`lg:p-16px w-full `}>
                    <h3 class={`text-medium-blue  fs-0`}>{this.jobsText}</h3>
                    <a class={`card-overlay group-target`} href={`/job-listing`}></a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </Host>
    );
  }
}
